import { ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { MY_DASHBOARD_FILTER_QUERY } from "graphql/mydashboardFilter";

const getBearerToken = () => {
  try {
    return localStorage.getItem("accessToken") || "";
  } catch {
    return "";
  }
};

let myDashboardFilterClient = null;

const getMyDashboardFilterClient = () => {
  if (myDashboardFilterClient) {
    return myDashboardFilterClient;
  }

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_DOORSHARP_GRAPHQL_ENDPOINT,
  });

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      "Content-Type": "application/json",
      ...(getBearerToken() ? { Authorization: `Bearer ${getBearerToken()}` } : {}),
    },
  }));

  myDashboardFilterClient = new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: "network-only",
        errorPolicy: "all",
      },
    },
  });

  return myDashboardFilterClient;
};

export async function fetchMyDashboardFilter() {
  try {
    const client = getMyDashboardFilterClient();

    const { data } = await client.query({
      query: MY_DASHBOARD_FILTER_QUERY,
      fetchPolicy: "network-only",
    });

    console.log("My Dashboard Filter GraphQL response:", data);
    return data;
  } catch (error) {
    console.error("My Dashboard Filter GraphQL error:", error);
    throw error;
  }
}

